import { Component } from '@angular/core';

@Component({
  selector: 'app-samples-settings',
  templateUrl: './settings.component.html',
  standalone: false
})
export class SettingsComponent {
  constructor() {}
}
